var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dea-tooltip"},[_c('div',{staticClass:"dea-tooltip__inner",class:[
      { 'dea-tooltip__inner--negative': _vm.negative },
      ("dea-tooltip__inner--" + _vm.side),
      ("dea-tooltip__inner--" + _vm.side + "--" + _vm.position) ]},[_c('div',{staticClass:"dea-tooltip__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }